export const numberFormat = (number: string, country = 'en-US', digits = 3): string => {
  if (number) {
    const convertToFloat = parseFloat(number);
    return new Intl.NumberFormat(country, {
      minimumFractionDigits: digits,
    }).format(convertToFloat);
  }
  return '--';
};
